import OkC from "shared/util/OkcApi";

export function getPreferenceInfo() {
	return OkC.get("/global_preferences");
}

export function setPreferenceInfo(prefs) {
	return OkC.post("/global_preferences", {
		data: prefs,
	});
}



// WEBPACK FOOTER //
// ./src/apps/global_preferences/util/web.js